//* 翻译集
import zh from "./language/zh.json";
import en from "./language/en.json";

import { createI18n } from "vue-i18n";

export const i18nOption = {
    locale: "en",
    legacy: false,
    fallbackLocale: "zh",
    globalInjection: true,
    messages: { zh, en },
    locales: [
        { code: "zh", iso: "zh-CN", file: "zh.json" },
        { code: "en", iso: "en-US", file: "en.json" },
    ],
};

export const i18n = createI18n(i18nOption);
